import React, { useMemo, useState } from 'react'
import SweetAlert from 'react-bootstrap-sweetalert'
import { useSelector } from 'react-redux'
import { isDarkTheme } from 'src/selectors/ThemeSelector'

const initState = {
  visible: false,
  message: '',
  warning: true,
  success: false,
  info: false,
  danger: false,
  title: '',
  onConfirm: () => {},
  onCancel: () => {},
  showCancel: true,
  showConfirm: true,
  focusCancelBtn: true,
  input: false,
  inputType: 'text',
  confirmBtnText: 'Confirm',
  cancelBtnText: 'Cancel',
  customButtons: '',
}

const UseSweetAlert = () => {
  const [state, setState] = useState(initState)
  const isDark = useSelector(isDarkTheme)

  const showAlert = (props = {}) => {
    setState({
      ...initState,
      ...props,
      visible: true,
    })
  }

  const alert = useMemo(() => {
    const alertComponent = () => {
      return state.visible ? (
        <SweetAlert
          style={isDark ? { backgroundColor: '#1e1e2d', color: 'gray-100' } : undefined}
          warning={state.warning}
          success={state.success}
          danger={state.danger}
          info={state.info}
          title={<span className="lead fw-bold">{state.title}</span>}
          confirmBtnText={state.confirmBtnText}
          cancelBtnText={state.cancelBtnText}
          confirmBtnColor={state.confirmBtnColor}
          cancelBtnColor={state.cancelBtnColor}
          confirmBtnBsStyle="primary"
          cancelBtnBsStyle="light"
          onConfirm={(response) => {
            if (state.onConfirm) {
              state.onConfirm(response)
            }
            setState(initState)
          }}
          onCancel={() => {
            if (state.onCancel) {
              state.onCancel()
            }
            setState(initState)
          }}
          showCancel={state.showCancel}
          showConfirm={state.showConfirm}
          focusCancelBtn={state.focusCancelBtn}
          input={state.input}
          required={state.input}
          inputType={state.inputType}
          customButtons={state.customButtons}
        >
          {state.message}
        </SweetAlert>
      ) : (
        <></>
      )
    }

    return alertComponent
  }, [state, isDark])

  return [alert, showAlert]
}

export default UseSweetAlert
